import Vue from 'vue'
import router from './router'
import App from './App.vue'
import axios from 'axios'
import Mint from 'mint-ui'
import config from './config'
import init from '@ivy/fts'
import store from './store/store'
import { closeAll } from '@ivy/fts/showDiv'
import anime from 'animejs'
import directiveInstall from './directives'
import VueLazyload from 'vue-lazyload'
import VueClipboard from 'vue-clipboard2'

let InfiniteScroll = Mint.InfiniteScroll
Vue.use(InfiniteScroll)
Vue.config.devtools = true
directiveInstall(Vue)
declare module 'vue/types/vue' {
  interface Vue {
    $anime: any
  }
}
init({ Vue, router, axios, config, Mint })
Vue.use(VueLazyload, {
  preLoad: 1,
  error: require('../static/ivy-logo.png'),
  loading: require('../static/loading.gif'),
  attempt: 3,
})
Vue.use(VueClipboard)
Vue.prototype.$store = store
Vue.prototype.$anime = anime
Vue.config.productionTip = false
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
  closeAll()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
